<template>
  <div class="engagement-section">
    <div class="engagement-content">
      <PatientEngagementOverTimeChart />
      <PatientEngagementQualitySection />
    </div>
  </div>
</template>

<script setup>
import PatientEngagementOverTimeChart from './PatientEngagementOverTimeChart.vue';
import PatientEngagementQualitySection from './PatientEngagementQualitySection.vue';
</script>

<style scoped>
.engagement-section {
  background: #F9FBFD;
  border-radius: 10px;
  padding: 16px 24px;
}

.engagement-content {
  display: flex;
  gap: 24px;
  width: 100%;
}

.engagement-content > :first-child {
  flex: 3;
  min-width: 0;
}

.engagement-content > :last-child {
  width: 25%;
  min-width: 0;
}
</style>
